import React from "react";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import ArrowIcon from "@material-ui/icons/ArrowRightAltOutlined";
import { makeStyles } from "@material-ui/core/styles";

import AgentSelect from "./AgentSelect";

// Editor das rotas valor→agente do nó "Rotear para agente": cada linha mapeia um
// valor (do campo "Rotear por") para um agente que assume a ligação.
const useStyles = makeStyles(theme => ({
  row: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8 },
  val: { width: 130, flexShrink: 0 },
  arrow: { color: theme.app.textTertiary, flexShrink: 0 },
  agent: { flex: 1, minWidth: 0 },
  empty: { fontSize: 12.5, color: theme.app.textTertiary, padding: "2px 0 8px" },
}));

const RouteAgentEditor = ({ value, onChange, projectId, disabled }) => {
  const classes = useStyles();
  const routes = Array.isArray(value) ? value : [];

  const patch = (i, key, v) => onChange(routes.map((r, idx) => (idx === i ? { ...r, [key]: v } : r)));
  const add = () => onChange([...routes, { value: "", agentId: "" }]);
  const remove = i => onChange(routes.filter((_, idx) => idx !== i));

  return (
    <div>
      {routes.length === 0 && <div className={classes.empty}>Nenhuma rota. Adicione "valor → agente".</div>}
      {routes.map((r, i) => (
        <div key={i} className={classes.row}>
          <TextField
            className={classes.val}
            label="Valor"
            placeholder="suporte"
            value={r.value || ""}
            onChange={e => patch(i, "value", e.target.value)}
            size="small"
            variant="outlined"
            disabled={disabled}
          />
          <ArrowIcon className={classes.arrow} fontSize="small" />
          <div className={classes.agent}>
            <AgentSelect
              value={r.agentId}
              onChange={v => patch(i, "agentId", v)}
              label="Agente"
              projectId={projectId}
              disabled={disabled}
            />
          </div>
          {!disabled && (
            <IconButton size="small" onClick={() => remove(i)} title="Remover">
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      ))}
      {!disabled && (
        <Button size="small" variant="outlined" color="secondary" startIcon={<AddIcon />} onClick={add}>
          Adicionar rota
        </Button>
      )}
    </div>
  );
};

export default RouteAgentEditor;
